import React from 'react';
import {
    faTrash,
    faGasPump,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { STATUS_EXCUTED, STATUS_IN_PROGRESS } from '../../../../api/constant';
import { useActionsHandOut, useDispatchHandOutForm, useHandOut } from '../../../../context/inventory/HandOutFormProvider';
import { formatNumberCOP } from '../../../../utilities/app.utilities';
import { alertWarning } from '../../../../utilities/alerts.utilities';
import Select from "react-select";
import { customStyles } from "../../../../utilities/select-styles.utilities";
import { types } from "../../../../reducers/inventory/handOutReducer";



export const ConsumeItemHandOut = (items) => {
    const state = useHandOut();
    const actions = useActionsHandOut();
    const dispatch = useDispatchHandOutForm();
    const {
        movement: {
            status_id,
        },
        item,
    } = state;


    const refill = ()=>{
        console.log('consumido');
    }

    const filter_list_inventory = items.items.filter((item)=> item.consume!=="0")

    if (items.items.length>0) {
        return(
            <div className="col-md-12 col-lg-12 mt-4">
            <div className="flex1">
                <table className="table table-default-app">
                    <thead className="thead-dark">
                        <tr>
                            <th scope="col">id articulo</th>
                            <th scope="col">nombre</th>

                            <th scope="col">Lote</th>
                            <th scope="col">F. vencimiento</th>
                            <th scope="col">Und. medida lote</th>
                            <th className="td-inventory-out-test" scope="col">
                                Cant. Consumo lote
                            </th>
                            <th scope="col">Und. medida consumo</th>
                            <th scope="col">Cant. Consumo</th>
                        </tr>
                    </thead>
                    <tbody>
                        {status_id === STATUS_IN_PROGRESS ?
                            items.items.map((item, index) => {
                                if (item.date_expired === "2300-12-31") {
                                    item.lote = "N.A"
                                    item.date_expired = "N.A";
                                  }
                                  if (item.date_expired==null) {
                                    item.date_expired = "N.A";
                                  }
                                return (
                                    <tr key={item.id} 
                                    onClick={(e) => {
                                        actions.getLotesByItemHandOutForClickLoteConsume(item.item_id, {name_article: item.name_article, measure_name_lote: item.measure_name_lote});
                                        }
                                      }
                                    
                                      className='td-hoverme cursor-pointer' 
                                    >
                                        <td>{item.code_article}</td>
                                        <td>{item.name_article}</td>

                                        <td>{item.lote}</td>
                                        <td>{item.date_expired}</td>
                                        <td>{item.measure_name_lote}</td>
                                        <td className="txt-right td-inventory-out-test">
                                            {formatNumberCOP(item.consume_lote)}
                                        </td>
                                        {/* esta es para consumo */}
                                        <td>
                                            <Select
                                            value={state.measures.measures.filter((measure)=> measure.id=== item.measure_consume_id)}
                                            placeholder="Unidad de consumo"
                                            getOptionLabel={(option) => option.name}
                                            getOptionValue={(option) => option.id}
                                            options={state.measures.measures.filter((filter_type)=> filter_type.type=== item.und_measure_type)}
                                            styles={customStyles}
                                            isDisabled={status_id === STATUS_EXCUTED}
                                            onChange={(e) =>
                                                actions.setMeasureConsume(e.id, index)
                                              }
                                             />
                                        </td> 
                                        <td className="txt-right bg-consume">
                                            <div className="">
                                                {" "}
                                                {status_id === STATUS_IN_PROGRESS ? (
                                                    <input
                                                        className="input-consume-out-test bg-consume"
                                                        value={item.consume}
                                                        onChange={(e) =>
                                                            actions.setConsume(e.target.value, index)
                                                        }
                                                        onBlur={() => actions.consumeToMovementOutManually(index)}
                                                        type="number"
                                                    />
                                                ) : (
                                                    formatNumberCOP(item.consume)
                                                )}
                                            </div>
                                        </td>
                                        {status_id !== STATUS_EXCUTED ?
                                            <th>
                                                <FontAwesomeIcon
                                                    onClick={() =>
                                                        actions.deleteDetailMovementByHeader(item.id)
                                                    }
                                                    className="blue cursor-pointer"
                                                    title="Borrar articulo"
                                                    icon={faTrash}
                                                />
                                            </th>
                                            :
                                            <></>}
                                    </tr>
                                );
                            })
                            :
                            filter_list_inventory.map((item, index) => {
                                if (item.date_expired === "2300-12-31") {
                                    item.lote = "N.A"
                                    item.date_expired = "N.A";
                                  }
                                return (
                                    <tr key={index}>
                                        <td>{item.code_article}</td>
                                        <td>{item.name_article}</td>

                                        <td>{item.lote}</td>
                                        <td>{item.date_expired}</td>
                                        <td>{item.measure_name_lote}</td>
                                        <td className="txt-right td-inventory-out-test">
                                            {formatNumberCOP(item.consume_lote)}
                                        </td>
                                        <td>{item.measure_name_consume}</td>
                                        <td className="txt-right">
                                            <div className="">
                                                {" "}
                                                {status_id === STATUS_IN_PROGRESS ? (
                                                    <input
                                                        className="input-consume-out-test"
                                                        value={item.consume}
                                                        onChange={(e) =>
                                                            actions.setConsume(e.target.value, index)
                                                        }
                                                        onBlur={() => actions.addOutToMovement(index)}
                                                        type="number"
                                                    />
                                                ) : (
                                                    formatNumberCOP(item.consume)
                                                )}
                                            </div>
                                        </td>
                                        {status_id !== STATUS_EXCUTED ?
                                            <th>
                                                <FontAwesomeIcon
                                                    onClick={() =>
                                                        refill(
                                                            item.value_unit_conversion * item.stock
                                                            +
                                                            item.consume
                                                            ,
                                                            index
                                                        )
                                                    }
                                                    className="blue cursor-pointer"
                                                    title="Borrar"
                                                    icon={faGasPump}
                                                />
                                            </th>
                                            :
                                            <></>}
                                    </tr>
                                );
                            })
                        }

                    </tbody>
                </table>
            </div>
        </div>
        )
    }
}
